import { createContext } from "react";

const MensajeContext = createContext();

export default MensajeContext;
